module.exports = "mutation ($id: ID!, $data: ResidentialTemplateUpdate!) {\n  ResidentialTemplateUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"